import { AfterViewInit, Component, OnInit, ViewChild, inject, DestroyRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ActivationEnd, NavigationStart, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToolbarButton } from '../../models/toolbar-button/toolbar-button';
import { RouterSegments } from '../../models/router-segments';
import { ContactUsDialogComponent } from './contact-us-dialog/contact-us-dialog.component';
import { SidenavService } from '../../services/util/sidenav.service';
import { Permission } from 'src/app/models/principal/permission';
import { MatDialog } from '@angular/material/dialog';
import { UpgradePlanDialogComponent } from '../../main/service/upgrade-plan-dialog/upgrade-plan-dialog.component';
import { PermissionsService } from '../../services/util/permissions.service';
import { Authority } from 'src/app/models/principal/authority';
import { NotificationsListComponent } from '../../components/notifications/notifications-list/notifications-list.component';
import { NotificationsService } from 'src/app/services/api/notifications.service';
import { translate } from '@jsverse/transloco';
import { MatMenu } from '@angular/material/menu';

const REQUIRED_PERMISSIONS = [
  Permission.UPGRADE_ENTERPRISE,
  Permission.DOWNLOAD_IAC
];

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false
})
export class ToolbarComponent implements OnInit, AfterViewInit {

  @ViewChild('hamburgerMenu', { static: true }) private hamburgerMenu: MatMenu;
  ToolbarButton = ToolbarButton;
  RouterSegments = RouterSegments;
  tenant: string;
  activeLink: string;
  hasMySandboxPermission: boolean;
  permissionsMap: {[key: string]: boolean};
  Permission = Permission;
  private destroyRef = inject(DestroyRef);
  authorities: boolean;

  constructor(public authService: AuthService, private router: Router, private sidenavService: SidenavService,
              private matDialog: MatDialog, private permissionsService: PermissionsService,
              public notificationsService: NotificationsService) {
    this.getActiveLink();
  }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
    this.authorities = this.authService.principal.authorities.length > 0 ? true : false;
    this.hasMySandboxPermission = !this.authService.hasPermission(Permission.VIEW_ENTERPRISE);
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);
  }

  ngAfterViewInit(): void {
    this.hamburgerMenu.overlayPanelClass = 'hamburger-menu-overlay-panel';
  }

  openPlanModal(): void {
    this.matDialog.open(UpgradePlanDialogComponent, {
      maxHeight: '100vh',
      minHeight: '90vh',
      backdropClass: 'upgrade-plans-backdrop',
      maxWidth: '1400px',
    });
  }

  openContactUsForm(): void {
    // this.sidenavService.openInRightSidenav(ContactUsDialogComponent);
    window.open('https://itsm-servicedesk.temenos.com/', '_blank');
  }

  openNotificationsModal(): void {
    const data = {
      title: translate('NOTIFICATIONS.NOTIFICATIONS')
    };

    this.sidenavService.openInRightSidenav(NotificationsListComponent, data);
  }
  /**
   * Gets the active link from the router data. Angular provides data to components inside the url tree, in which they are in. Therefore no
   * data is returned if we simply inject an instance of ActivatedRoute in components outside that tree (for instance the toolbar
   * component). We need to traverse all events and find the one with available activeLink data.
   *
   * https://github.com/angular/angular/issues/11812
   */
  private getActiveLink(): void {
    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event: any) => {
        if (event instanceof NavigationStart) {
          // reset upon new navigation to allow the value of activeLink to change
          this.activeLink = null;
        } else if (event instanceof ActivationEnd && event?.snapshot?.data.activeLink) {
          this.activeLink = event.snapshot.data.activeLink;
        }
      });
  }
}
